// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--bf60a";
export var screen1__bottom = "style-module--screen1__bottom--45975";
export var screen1__col = "style-module--screen1__col--b5191";
export var screen1__costOld = "style-module--screen1__cost-old--8cea9";
export var screen1__mainDesc = "style-module--screen1__main-desc--d088e";
export var screen1__row = "style-module--screen1__row--6c6de";